import { Service } from '../config'

class AddressService extends Service {
  path = 'endereco'

  async getCep(cep: string) {
    const httpResponse = await this.httpClient.get(this.path + `/${cep}`)
    return httpResponse
  }

  async getStates() {
    const httpResponse = await this.httpClient.get(this.path + `/estado`)
    return httpResponse
  }

  async getCities(uf: string) {
    const httpResponse = await this.httpClient.get(this.path + `/cidade/${uf}`)
    return httpResponse
  }

  async getStatesAndCities(payload = {}) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/cidade/uf`,
      payload
    )
    return httpResponse
  }
}

export const addressService = new AddressService()
